export function Welcome() {
  return <h1>Welcome to movie app!!!</h1>;
}
